<p-toggleswitch
  name="isRollUp"
  [(ngModel)]="isRollUp"
  (onChange)="onIsRoolUpReportChange(isRollUp)"
  class="top-margin small-toggle"
  pTooltip="Rollup children items"
  tooltipPosition="left"></p-toggleswitch>
